// extracted by mini-css-extract-plugin
export var checkbox = "_7d-0";
export var circle = "_7d-3";
export var horizontalContainer = "_7d-7";
export var sm = "_7d-5";
export var switch0 = "_7d-2";
export var switchDisabled = "_7d-8";
export var switchEnabled = "_7d-1";
export var textSwitchContainer = "_7d-9";
export var textSwitchOption = "_7d-a";
export var textSwitchOptionSelected = "_7d-b";
export var verticalContainer = "_7d-6";
export var xs = "_7d-4";